// extracted by mini-css-extract-plugin
module.exports = {"Offerings":"Offerings_Offerings__1w0t7","Description":"Offerings_Description__3FgQj","Wrapper":"Offerings_Wrapper__dCxcv"};